"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.EmailAddress = exports.ConstantEmailAddress = void 0;
exports.validator = validator;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _i18next = _interopRequireDefault(require("i18next"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _inRange = _interopRequireDefault(require("lodash/inRange"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _classnames = _interopRequireDefault(require("classnames"));
var Yup = _interopRequireWildcard(require("yup"));
var _utils = require("../../utils");
var _formik = require("formik");
var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));
var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));
var _CircularLoader = _interopRequireDefault(require("../CircularLoader"));
var _FormLabel = _interopRequireDefault(require("../FormLabel"));
var _Button = _interopRequireDefault(require("../Button"));
var _Input = _interopRequireDefault(require("../Input"));
var _FieldPrompt = _interopRequireDefault(require("./FieldPrompt"));
var _Header = _interopRequireDefault(require("./Header"));
var _excluded = ["errors"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function validator(email, _ref) {
  var emailRegex = _ref.emailRegex,
    minLength = _ref.minLength,
    maxLength = _ref.maxLength;
  var res = '';
  if (email.length === 0) {
    return res;
  }
  if (!(0, _inRange["default"])(email.length, minLength, maxLength + 1)) {
    res = _i18next["default"].t('signup.form.email.length', {
      minChars: minLength
    });
  } else if (!(0, _utils.isAlphaNum)(email.charAt(0)) || !(0, _utils.isAlphaNum)(email.charAt(email.length - 1))) {
    res = _i18next["default"].t('signup.form.email.beginEndAlpha');
  } else if (!emailRegex.test(email)) {
    res = _i18next["default"].t('signup.form.email.invalid');
  } else if (email.toLowerCase() !== email) {
    res = _i18next["default"].t('signup.form.email.lowercase');
  }
  if (!res) {
    try {
      Yup.string().email().validateSync("".concat(email).concat(_i18next["default"].t('signup.form.email.suffix')));
    } catch (_unused) {
      res = _i18next["default"].t('signup.form.email.invalid');
    }
  }
  return res;
}
var ChooseEmailAddress = function ChooseEmailAddress(_ref2) {
  var isLoading = _ref2.isLoading,
    isUsernameTaken = _ref2.isUsernameTaken,
    _validate = _ref2.validate,
    onSubmit = _ref2.onSubmit,
    onLogin = _ref2.onLogin,
    initialValues = _ref2.initialValues,
    emailRegex = _ref2.emailRegex,
    minLength = _ref2.minLength,
    maxLength = _ref2.maxLength,
    premiumBounds = _ref2.premiumBounds,
    _ref2$showUpgradeButt = _ref2.showUpgradeButton,
    showUpgradeButton = _ref2$showUpgradeButt === void 0 ? function () {
      return false;
    } : _ref2$showUpgradeButt;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var form = (0, _react.useRef)();

  // Weird bug with Formik when validation is not run on mount
  // https://github.com/formium/formik/issues/288#issuecomment-469428691
  (0, _react.useEffect)(function () {
    if (form.current) {
      form.current.getFormikActions().validateForm();
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    ref: form,
    id: "emailForm"
    // Avoid auto-submit without validation in Safari
    ,
    onSubmit: _noop["default"],
    initialValues: initialValues,
    validate: function validate(values) {
      var res = validator(values.email, {
        emailRegex: emailRegex,
        minLength: minLength,
        maxLength: maxLength
      });

      // Only send request if the email is valid
      if ((0, _isEmpty["default"])(res)) {
        _validate(values.email);
      }
      return res ? {
        email: res
      } : {};
    },
    validateOnBlur: false
  }, function (_ref3) {
    var errors = _ref3.errors,
      values = _ref3.values,
      isValid = _ref3.isValid;
    var isPremiumUsername = !(0, _isNil["default"])(premiumBounds) && (0, _inRange["default"])(values.email.length, premiumBounds.min, premiumBounds.max);
    var isSubmittable = isValid && !(0, _isEmpty["default"])(values.email) && (0, _isEmpty["default"])(errors) && !isUsernameTaken && !isLoading;
    var showWarning = !isLoading && !isUsernameTaken && isPremiumUsername && (0, _inRange["default"])(values.email.length, minLength, maxLength);
    return /*#__PURE__*/_react["default"].createElement(_Fade["default"], {
      "in": true
    }, /*#__PURE__*/_react["default"].createElement(_formik.Form, {
      className: "flex flex-col justify-between w-full min-h-full"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex flex-col justify-center flex-grow px-3"
    }, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
      className: "mb-3"
    }, t('signup.form.email.header')), /*#__PURE__*/_react["default"].createElement(EmailInput, null), /*#__PURE__*/_react["default"].createElement(Availability, {
      values: values,
      errors: errors,
      isLoading: isLoading,
      isUsernameTaken: isUsernameTaken,
      isPremium: isPremiumUsername
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "md:hidden"
    }, /*#__PURE__*/_react["default"].createElement(LoginMessage, {
      onLogin: onLogin
    }), /*#__PURE__*/_react["default"].createElement(Warning, {
      values: values,
      className: (0, _classnames["default"])({
        hidden: !showWarning
      })
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "fixed bottom-0 w-full shadow-hover md:static md:px-3 md:shadow-none"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "hidden md:block"
    }, /*#__PURE__*/_react["default"].createElement(Warning, {
      values: values,
      className: (0, _classnames["default"])({
        invisible: !showWarning
      })
    }), /*#__PURE__*/_react["default"].createElement(LoginMessage, {
      onLogin: onLogin
    })), /*#__PURE__*/_react["default"].createElement(ContinueButton, {
      disabled: !isSubmittable,
      onClick: function onClick() {
        return onSubmit(values.email);
      },
      upgradable: showUpgradeButton(values.email)
    }))));
  });
};
var Availability = function Availability(_ref4) {
  var values = _ref4.values,
    errors = _ref4.errors,
    isLoading = _ref4.isLoading,
    isUsernameTaken = _ref4.isUsernameTaken,
    isPremium = _ref4.isPremium;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  var children = isUsernameTaken === false ? !isPremium ? t('signup.form.email.available') : t('signup.form.email.premiumAvailable') : !(0, _isNil["default"])(isUsernameTaken) && t('signup.form.email.unavailable');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex flex-col md:flex-row justify-between items-baseline pt-5', {
      invisible: values.email.length === 0
    })
  }, errors.email && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-red"
  }, errors.email), !errors.email && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('hidden md:block text-2xl font-bold max-w-full whitespace-pre-wrap break-all mr-5', {
      'text-light': isUsernameTaken !== false
    })
  }, "".concat(values.email).concat(t('signup.form.email.suffix'))), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('font-bold', {
      'text-light': isUsernameTaken !== false,
      'text-green': isUsernameTaken === false
    })
  }, children), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('flex-shrink-0', {
      hidden: !isLoading
    })
  }, isUsernameTaken === null && /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], {
    size: "1rem"
  }))));
};
var EmailInput = function EmailInput() {
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    htmlFor: "email",
    className: "hidden"
  }, "Email Address"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col md:flex-row md:items-center justify-center mt-3"
  }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    autoFocus: true,
    name: "email",
    autoComplete: "off",
    className: "block w-full px-0 md:px-4 py-3 font-bold text-dark"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-0 md:ml-3 text-2xl font-semibold text-primary"
  }, t('signup.form.email.suffix'))));
};
var LoginMessage = function LoginMessage(_ref5) {
  var onLogin = _ref5.onLogin;
  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation4.t;
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: "pb-3 text-xs text-light hidden md:block my-8"
  }, t('signup.login.1'), ' ', /*#__PURE__*/_react["default"].createElement("span", {
    className: "cursor-pointer text-primary",
    onClick: onLogin
  }, t('signup.login.2')));
};
var Warning = function Warning(_ref6) {
  var values = _ref6.values,
    className = _ref6.className;
  var _useTranslation5 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation5.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('my-6 md:px-0', className)
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-xs md:text-sm text-medium"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-green mr-2"
  }, /*#__PURE__*/_react["default"].createElement(_Error["default"], {
    fontSize: "small"
  })), /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "signup.planRestrictions",
    values: {
      email: "".concat(values.email).concat(t('signup.form.email.suffix'))
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-bold"
  }))));
};
var ContinueButton = function ContinueButton(_ref7) {
  var onClick = _ref7.onClick,
    disabled = _ref7.disabled,
    upgradable = _ref7.upgradable;
  var _useTranslation6 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation6.t;
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    type: "submit",
    className: "w-full md:w-1/2 md:mb-6",
    onClick: onClick,
    disabled: disabled
  }, upgradable && !disabled ? t('signup.form.email.upgrade') : t('button.continue'));
};
var EmailAddress = exports.EmailAddress = function EmailAddress(_ref8) {
  var disabled = _ref8.disabled,
    _validate2 = _ref8.validate,
    emailRegex = _ref8.emailRegex,
    minLength = _ref8.minLength,
    maxLength = _ref8.maxLength,
    premiumBounds = _ref8.premiumBounds,
    isUsernameTaken = _ref8.isUsernameTaken,
    isLoading = _ref8.isLoading;
  var ref = (0, _react.useRef)();
  var _useTranslation7 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation7.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    focused = _useState2[0],
    setFocus = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "email",
    validate: function validate(value) {
      var res = validator(value, {
        emailRegex: emailRegex,
        minLength: minLength,
        maxLength: maxLength
      });

      // Only send request if the email is valid
      if ((0, _isEmpty["default"])(res)) {
        _validate2(value);
      }
      return res;
    }
  }, function (_ref9) {
    var field = _ref9.field,
      _ref9$form = _ref9.form,
      errors = _ref9$form.errors,
      formProps = (0, _objectWithoutProperties2["default"])(_ref9$form, _excluded);
    var isPremiumUsername = !(0, _isNil["default"])(premiumBounds) && (0, _inRange["default"])(field.value.length, premiumBounds.min, premiumBounds.max);
    var showPopper = focused && field.value.length > 0 && !errors.email;
    var showWarning = !isLoading && !isUsernameTaken && isPremiumUsername && (0, _inRange["default"])(field.value.length, minLength, maxLength);
    var prompt = '';
    if (field.value.length === 0) {
      prompt = t('signup.form.email.prompt');
    } else if (isUsernameTaken) {
      prompt = t('signup.form.email.prompt.unavailable');
    } else {
      prompt = errors.email;
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "relative"
    }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
      htmlFor: "email"
    }, "Email Address"), /*#__PURE__*/_react["default"].createElement("div", {
      ref: ref,
      className: "flex items-center justify-center bg-secondary rounded"
    }, /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({}, field, {
      standalone: true,
      size: "lg",
      autoFocus: !disabled,
      disabled: disabled,
      autoComplete: "off",
      onFocus: function onFocus() {
        return setFocus(true);
      },
      onBlur: function onBlur(e) {
        field.onBlur(e);
        setFocus(false);
      },
      className: "block w-full font-bold text-dark"
    })), /*#__PURE__*/_react["default"].createElement("span", {
      className: "px-4 text-lg font-semibold text-light"
    }, t('signup.form.email.suffix'))), /*#__PURE__*/_react["default"].createElement(_FieldPrompt["default"], {
      variant: isUsernameTaken || !!errors.email ? 'error' : 'info'
    }, prompt), /*#__PURE__*/_react["default"].createElement(_Popper["default"], {
      disablePortal: true,
      open: showPopper,
      placement: "bottom-start",
      anchorEl: ref.current,
      className: "z-50 w-full bg-card shadow-lg dark:shadow-deep mt-2 px-4"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('pt-3 font-bold flex justify-between', {
        'pb-3': !showWarning
      })
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-light text-lg flex-1 truncate pr-2 hidden md:block"
    }, field.value), isLoading ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "px-2 w-full md:w-auto"
    }, /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], {
      fullHeight: true,
      size: 20
    })) : isUsernameTaken ? /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-light"
    }, t('signup.form.email.unavailable')) : /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-green"
    }, isPremiumUsername ? t('signup.form.email.premiumAvailable') : t('signup.form.email.available'))), showWarning && /*#__PURE__*/_react["default"].createElement(Warning, {
      values: {
        email: field.value
      },
      className: "!mb-3"
    })));
  });
};
var ConstantEmailAddress = exports.ConstantEmailAddress = function ConstantEmailAddress(_ref10) {
  var name = _ref10.name,
    email = _ref10.email;
  if (!name && !email) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "rounded"
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    name: name
  }, "Email Address"), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
    disabled: true,
    size: "lg",
    name: name,
    value: email,
    standalone: !name,
    className: "block w-full font-bold border-none bg-secondary"
  }));
};
var _default = exports["default"] = ChooseEmailAddress;
//# sourceMappingURL=ChooseEmailAddress.js.map